function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsx jsx */
import { useTranslation } from '@datacamp/le-shared-components';
import { Button } from '@datacamp/waffles/button';
import { ArrowLeft } from '@datacamp/waffles/icon';
import { css, jsx } from '@emotion/react';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var _ref = "production" === "production" ? {
  name: "1e1ncky",
  styles: "border:none"
} : {
  name: "15zs75-BackButton",
  styles: "border:none;label:BackButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9CYWNrQnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFlYyIsImZpbGUiOiIuLi9zcmMvQmFja0J1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IHVzZVRyYW5zbGF0aW9uIH0gZnJvbSAnQGRhdGFjYW1wL2xlLXNoYXJlZC1jb21wb25lbnRzJztcbmltcG9ydCB7IEJ1dHRvbiB9IGZyb20gJ0BkYXRhY2FtcC93YWZmbGVzL2J1dHRvbic7XG5pbXBvcnQgeyBBcnJvd0xlZnQgfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy9pY29uJztcbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxudHlwZSBCYWNrQnV0dG9uUHJvcHMgPSB7XG4gIG9uQ2xpY2s6ICgpID0+IHZvaWQ7XG59O1xuXG5leHBvcnQgY29uc3QgQmFja0J1dHRvbjogUmVhY3QuRkM8QmFja0J1dHRvblByb3BzPiA9ICh7IG9uQ2xpY2sgfSkgPT4ge1xuICBjb25zdCB7IHQgfSA9IHVzZVRyYW5zbGF0aW9uKCk7XG4gIHJldHVybiAoXG4gICAgPEJ1dHRvblxuICAgICAgY3NzPXtjc3NgXG4gICAgICAgIGJvcmRlcjogbm9uZTtcbiAgICAgIGB9XG4gICAgICBkYXRhLWN5PXsnYmFjay1idXR0b24nfVxuICAgICAgb25DbGljaz17b25DbGlja31cbiAgICA+XG4gICAgICA8QXJyb3dMZWZ0IC8+XG4gICAgICB7dCgnTXVsdGlTdGVwSW5zdHJ1Y3Rpb25zLmJhY2snKSBhcyBzdHJpbmd9XG4gICAgPC9CdXR0b24+XG4gICk7XG59O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const BackButton = _ref2 => {
  let {
    onClick
  } = _ref2;
  const {
    t
  } = useTranslation();
  return jsx(Button, {
    css: _ref,
    "data-cy": 'back-button',
    onClick: onClick
  }, jsx(ArrowLeft, null), t('MultiStepInstructions.back'));
};